module.exports = __webpack_public_path__ + "static/reczebras-418a2447b87c77a0f0c993c0c81f08fb.png";